const unwrap = <T>(
  promiseResponse: PromiseSettledResult<T | null>
): T | null =>
  promiseResponse.status === 'fulfilled' ? promiseResponse.value : null;

export { unwrap };
